import { render, staticRenderFns } from "./applyType.vue?vue&type=template&id=3c31a9ea&scoped=true&"
import script from "./applyType.vue?vue&type=script&lang=js&"
export * from "./applyType.vue?vue&type=script&lang=js&"
import style0 from "./applyType.vue?vue&type=style&index=0&id=3c31a9ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31a9ea",
  null
  
)

component.options.__file = "applyType.vue"
export default component.exports